<template>
  <span
    :class="['checkbox', {
      checked: value,
    }]"
    @click="toggleCheck"
  >
    <img
      v-if="theme === 'dark'"
      v-show="!!value"
      src="./images/checked.svg"
      alt="Checked"
    >
    <img
      v-else
      v-show="!!value"
      src="./images/checked.png"
      alt="Checked"
    >
  </span>
</template>

<script>
export default {
  name: 'Checkbox',
  model: {
    prop: 'value',
    event: 'click'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    // 深色或者浅色，所用选中图不一样，默认为浅色, 支持 dark
    theme: {
      type: String,
      default: ''
    }
  },
  methods: {
    toggleCheck() {
      this.$emit('click', this.name)
    }
  }
}
</script>

<style lang="scss">
.checkbox {
  display: inline-block;
  width: 18px;
  height: 18px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 50%;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;

  &.checked {
    border: 0;
  }
}
</style>
